module.exports = __webpack_public_path__ + "static/media/form_lamaran.99bc702a.jpg";